import React from "react";
import {reportService} from "../../../services/domain/report/service";
import PdfViewer from "../../../components/shared/PdfViewer";

const CertificationPdfViewer: React.FC<any> = ({
                                                   visible,
                                                   onClose,
                                                   reportType,
                                                   title,
                                                   apiParam
                                               }) => {
    const loadPdfData = async () => {
        let response;
        switch (reportType) {
            case 'CertificationMembers':
                response = await reportService.getCertificationMembersPdf({
                    "certificationIds": apiParam.certificationIds
                });
                break;
        }
        return response
    };

    /**
     * Export PDF
     */
    const exportPdf = async (filename: string) => {
        // In production, we would handle different report types here
        switch (reportType) {
            case 'CertificationMembers': // 全會員證書
                await reportService.exportCertificationMembersPdf({
                    "certificationIds": apiParam.certificationIds
                });
                break;
        }
    };

    /**
     * Export Excel
     */
    const exportExcel = async (filename: string) => {
        // In production, we would handle different report types here
        switch (reportType) {
            case 'CertificationMembers': // 全會員證書
                await reportService.exportCertificationMembersExcel({
                    "certificationIds": apiParam.certificationIds
                });
                break;
        }
    };

    return (
        <PdfViewer visible={visible}
                   onClose={onClose}
                   title={title}
                   loadPdfData={loadPdfData}
                   exportPdf={exportPdf}
                   exportExcel={exportExcel}
        />
    );
};

export default CertificationPdfViewer;